import { defaultSearchStore } from 'owa-mail-search-store';
import searchStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
import { assertNever } from 'owa-assert';
/**
 * Set the current {@link SubstrateSearchSuggestionSegment} set in the store,
 * which are included in the user's search query.
 * @param segments The segments to use. If empty or less than 2, will instead
 *  unset the current segments.
 */
export default action('setSearchSegments')(function setSearchSegments(segments) {
    segments = segments || [];
    var lastSegment = segments.slice(-1)[0];
    var lastSegmentSearchInput = getSearchInputFromSegment(lastSegment);
    // To simplify client/server contract, we only allow the user to
    // have EITHER pills (client-side) OR segments (server-side).
    searchStore.suggestionPillIds = [];
    // Depending on the last segment's type, it can be displayed as either a pill
    // or searchbox text
    searchStore.searchText = lastSegmentSearchInput.searchText;
    searchStore.suggestionSegments = lastSegmentSearchInput.shouldBePill
        ? segments
        : segments.slice(0, -1);
});
function getSearchInputFromSegment(segment) {
    if (!segment) {
        return { searchText: defaultSearchStore.searchText, shouldBePill: false };
    }
    switch (segment.Type) {
        case 'Text':
            return { searchText: segment.Text, shouldBePill: false };
        case 'Person':
            return { searchText: defaultSearchStore.searchText, shouldBePill: true };
        default:
            return assertNever(segment);
    }
}
//# sourceMappingURL=setSearchSegments.js.map